import React from 'react';

const VariableAssignment = ({ variables, assignment, onAssignmentChange, onRandomize, onResetAll }) => {
  const toggleVariable = (variable) => {
    const newAssignment = { ...assignment };
    newAssignment[variable] = !newAssignment[variable];
    onAssignmentChange(newAssignment);
  };
  return (
    <div className="bg-white border-2 border-gray-300 rounded-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-bold text-xl text-gray-900">Variable Assignments</h3>
        <div className="flex gap-2">
          <button onClick={onResetAll} className="px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium">Reset All</button>
          <button onClick={onRandomize} className="px-4 py-2 border-2 border-blue-500 text-blue-600 rounded-lg hover:bg-blue-50 font-medium">Randomize</button>
        </div>
      </div>
      <div className="space-y-3">
        {variables.map(variable => {
          const value = assignment[variable];
          return (
            <div key={variable} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
              <span className="font-semibold text-lg text-gray-800">{variable}</span>
              <div className="flex items-center gap-3">
                <button onClick={() => toggleVariable(variable)} className={`relative inline-flex h-8 w-16 items-center rounded-full transition-colors ${value ? 'bg-teal-600' : 'bg-gray-300'}`}>
                  <span className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${value ? 'translate-x-9' : 'translate-x-1'}`} />
                </button>
                <span className={`font-bold min-w-[60px] ${value ? 'text-teal-600' : 'text-red-600'}`}>{value ? 'TRUE' : 'FALSE'}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VariableAssignment;